import React from 'react';
import Panel from './Panel';

/**
 * basically displays some content over its parent element, intended as placeholder for when there's nothing else to display but we still want the user to know its not an error
 * @export
 * @returns a semi-transparent overlay content
 */
export default function PlaceholderContent(props)
{
	return (
		<Panel className={!props.staticWidth ? "placeholderContent" : "placeholderContentStatic"}>
			<div className={"placeholderContentWrapper"}>
				{props.children}
			</div>
		</Panel>
	);
}